import type { ImageWithBoundingBoxesProps } from "./image-with-bounding-boxes.type";

import { BoundingBox } from "@/ui/bounding-box";
import { ImageWithData } from "@/ui/image-with-data";

export const ImageWithBoundingBoxes = ({
  src,
  alt,
  boundingBoxes,
  hideLabels,
}: ImageWithBoundingBoxesProps) => {
  return (
    <ImageWithData
      src={src}
      alt={alt}
      data={boundingBoxes.map((box) => (
        <BoundingBox key={box.key} box={box} hideLabel={hideLabels} />
      ))}
    />
  );
};
